module.exports = __webpack_public_path__ + "img/marketCopy.92043111.svg";